<template>
  <div class="widget" v-on:click="scheduleAction" v-show="!isHidden()" v-bind:class="{ disabled: isDisabled(), active: performingCurrentTask() }">
    <div :class="[ 'icon', 'md', iconClass() ]"></div>
    <span class="timer" v-if="performingCurrentTask()">
      {{ formatRemainingTimeCurrentTask() }}
    </span>
    <h3>{{ title }}</h3>
    <div class="description">
      {{ description }}
    </div>
    <span v-if="performingCurrentTask()">
      <ProgressBar v-bind:speed="8" v-bind:value="percent" v-bind:total="total" />
    </span>
  </div>
</template>

<script>
import ActionWidgetConfig from './ActionWidgetConfig'
import ProgressBar from '../ui/ProgressBar'

function formatSeconds (sec) {
  return [(sec / 3600), ((sec % 3600) / 60), ((sec % 3600) % 60)]
    .map(v => v < 10 ? '0' + parseInt(v) : parseInt(v))
    .filter((i, j) => i !== '00' || j > 0)
    .join(':')
}

export default {
  name: 'ActionWidget',
  props: [ 'action_id', 'player' ],
  components: { ProgressBar },
  methods: {
    iconClass () {
      return this.config().icon
    },
    formatRemainingTimeCurrentTask () {
      var seconds = Math.floor(this.player.action.workRemaining / 8)
      return formatSeconds(seconds)
    },
    performingCurrentTask () {
      return this.player.action !== null &&
        this.player.action.name === this.action_id
    },
    isHidden () {
      return this.config().isHidden(this.player, this.$store)
    },
    isDisabled () {
      return this.config().isDisabled(this.player, this.$store)
    },
    scheduleAction () {
      if (!this.isDisabled()) {
        this.$socket.emit('scheduleAction', {
          action: this.action_id
        })
      }
    },
    config () {
      return ActionWidgetConfig[this.action_id]
    }
  },
  computed: {
    title: {
      get () {
        return ActionWidgetConfig[this.action_id].title
      }
    },
    description: {
      get () {
        return ActionWidgetConfig[this.action_id].description
      }
    },
    percent: {
      get () {
        return this.player.action.workRemaining
      }
    },
    total: {
      get () {
        return this.player.action.workTotal
      }
    }
  }
}
</script>

<style>

.widget {
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */

    position: relative;
    overflow: hidden;
    background-color: rgba(0, 0, 0, .2);
    border-radius: 5px;

    display: block;

    margin: 5px;
    padding: 5px;

    cursor: pointer;
}
.widget.active,
.widget.disabled.active {
    color: #3d7940;
}

.widget h3 {
    display: block;
    font-weight: bold;
    font-size: 16px;
    margin: 0;
    padding: 0;
    border-bottom: 1px dotted #888;
    margin-left: 54px;
}
.widget .description {
    margin-left: 54px;
}

.widget.disabled {
    color: #a0a0a0;
    cursor: not-allowed;
}
.widget .description span {
    white-space: nowrap;
}

.widget .timer {
    float: right;
}

.widget .progress {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/ActionWidget.vue